// The animals at the glass. Art only, and by seed only: nothing here ever sees who is a visitor or a neighbour, so an animal
// can't give anyone away. Story mode, the lessons and the shared doors (a challenge, the Big Knock) keep their own faces.
export const ANIMALS = ['pigeon', 'cowboy', 'afrocat', 'hamster', 'frog', 'dog', 'goat', 'capy', 'owl', 'raccoon'];
export const ANIMAL_NAMES = { pigeon: 'a pigeon with a gold chain', cowboy: 'a dog in a cowboy hat', afrocat: 'a cat with an afro',
  hamster: 'a hamster in headphones', frog: 'a frog in a crown', dog: 'a French bulldog in sunglasses', goat: 'a goat in a Roman helmet',
  capy: 'a capybara with a towel on its head', owl: 'an owl in a nightcap', raccoon: 'a raccoon with a torch' };

const fmix = h => { h >>>= 0; h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16; return h >>> 0; };
// which animal a door shows, when it shows one
export const animalOf = seed => ANIMALS[fmix((seed ^ 0x51ed270b) >>> 0) % ANIMALS.length];

// The mix: about one door in four in the normal lineup wears an animal head. The rest keep the degen and drawn-neighbour rolls
// (game/degens.js, game/regulars.js). Its own salt, so no other roll moves.
export const ANIMAL_SHARE = 1 / 4;
export const animalMixOf = seed => (fmix((seed ^ 0x3c6ef372) >>> 0) / 4294967296 < ANIMAL_SHARE ? animalOf(seed) : null);

// Full fever: now and then every visitor is an animal for a short run of doors, then the mix comes back.
// Seeded like the glitch (game/glitch.js GLITCH_SHARE): about one door in 40 starts a run of 2 or 3 doors, so about one door in 16
// is a fever door. The server keeps each doorkeeper's run (game/engine.js) and tells the page, so the logbook and the glass agree.
// The glitch wins: toy town covers the head, and a fever never starts on a door where a glitch starts.
export const FEVER_SHARE = 1 / 40;
export function feverOf(seed) { // how many doors a fever that starts at this door lasts: 0 for none, else 2 or 3
  const h = fmix((seed ^ 0x7f4a7c15) >>> 0);
  if (h / 4294967296 >= FEVER_SHARE) return 0;
  return 2 + (fmix(h ^ 0x165667b1) & 1);
}
// One doorkeeper's run of doors: whether the next door is a fever door. state: { left } fever doors still to come.
// glitch: whether a glitch starts at this door (game/glitch.js glitchOf).
export function nextFever(state, seed, { glitch = false } = {}) {
  if (state.left > 0) return { fever: true, left: state.left - 1, started: false };
  const n = glitch ? 0 : feverOf(seed);
  return n ? { fever: true, left: n - 1, started: true } : { fever: false, left: 0, started: false };
}

// The old switch (until 2026-10): a top-bar toggle, a coin flip per browser, stored under 'door.fever'. The page no longer reads or
// writes that key, so a stored value does nothing. server/measure.js still reads the old fever_ tallies so their rows stay readable.
export const feverTally = (why, on) => `fever_${why}_${on ? 'on' : 'off'}`;
